/*
 * OWHG club-bundle cart UI.
 * Drives the live tier-progress message ("add N more clubs to save X%") from
 * the number of `club`-tagged items in the cart. Counting is by product handle
 * (window.OWHG_CLUB_HANDLES) since /cart.js line items don't expose tags.
 * Tiers come from window.OWHG_BUNDLE_TIERS (custom.bundle_tiers metafield).
 * Pure helpers are exposed on window.OWHGBundle for testing.
 * hickory-custom.js stays untouched — we monkey-patch OWHGCart.render.
 */
(function () {
  function tiers() {
    var t = (window.OWHG_BUNDLE_TIERS && window.OWHG_BUNDLE_TIERS.length)
      ? window.OWHG_BUNDLE_TIERS
      : [{ min: 2, pct: 5 }, { min: 3, pct: 10 }, { min: 5, pct: 15 }];
    return t.slice().sort(function (a, b) { return a.min - b.min; });
  }
  function clubSet() { return new Set(window.OWHG_CLUB_HANDLES || []); }

  function clubCount(cart) {
    if (!cart || !cart.items) return 0;
    var set = clubSet();
    return cart.items.reduce(function (n, it) {
      return set.has(it.handle) ? n + (it.quantity || 0) : n;
    }, 0);
  }
  function currentTier(count, t) {
    t = t || tiers();
    var cur = null;
    t.forEach(function (x) { if (count >= x.min) cur = x; });
    return cur;
  }
  function nextTier(count, t) {
    t = t || tiers();
    var nx = null;
    t.forEach(function (x) { if (x.min > count && (!nx || x.min < nx.min)) nx = x; });
    return nx ? { min: nx.min, pct: nx.pct, needed: nx.min - count } : null;
  }
  function s(n) { return n === 1 ? '' : 's'; }
  function messageFor(count) {
    var t = tiers(), cur = currentTier(count, t), nx = nextTier(count, t);
    if (count === 0) {
      return 'Build a set and save — add <strong>' + t[0].min + ' clubs</strong> for ' + t[0].pct + '% off at checkout.';
    }
    if (cur && nx) return "You'll save <strong>" + cur.pct + "%</strong> at checkout. Add <strong>" + nx.needed + ' more club' + s(nx.needed) + '</strong> to save ' + nx.pct + '%.';
    if (cur && !nx) return "Top tier — you'll save <strong>" + cur.pct + "%</strong> at checkout.";
    if (!cur && nx) return 'Add <strong>' + nx.needed + ' more club' + s(nx.needed) + '</strong> for ' + nx.pct + '% off at checkout.';
    return '';
  }
  function fillPct(count) {
    var t = tiers(), top = t[t.length - 1].min;
    return Math.min(100, Math.round((count / top) * 100));
  }

  window.OWHGBundle = { clubCount: clubCount, currentTier: currentTier, nextTier: nextTier, messageFor: messageFor };

  function update(cart) {
    var count = clubCount(cart);
    document.querySelectorAll('[data-bundle-progress]').forEach(function (box) {
      box.setAttribute('data-club-count', count);
      var msg = box.querySelector('[data-bundle-msg]');
      var fill = box.querySelector('[data-bundle-fill]');
      if (msg) msg.innerHTML = messageFor(count);
      if (fill) fill.style.width = fillPct(count) + '%';
    });
    // Real-time picker refresh: hide clubs already in the cart, re-show removed ones.
    var inCart = {};
    if (cart && cart.items) cart.items.forEach(function (i) { inCart[String(i.id)] = true; });
    document.querySelectorAll('.bundle-picker__card').forEach(function (card) {
      var b = card.querySelector('[data-variant]');
      if (b) card.style.display = inCart[String(b.getAttribute('data-variant'))] ? 'none' : '';
    });
  }

  function patch() {
    if (window.OWHGCart && !window.OWHGCart.__bundlePatched) {
      var orig = window.OWHGCart.render.bind(window.OWHGCart);
      window.OWHGCart.render = function (cart) { orig(cart); update(cart); };
      // The drawer auto-scrolls down on open (focus lands deep in the picker),
      // hiding the line items. Reset the scroll region to the top on open so the
      // customer always sees their cart first.
      if (typeof window.OWHGCart.open === 'function') {
        var origOpen = window.OWHGCart.open.bind(window.OWHGCart);
        window.OWHGCart.open = function () {
          origOpen();
          var sc = document.querySelector('.cart-drawer__scroll');
          if (sc) setTimeout(function () { sc.scrollTop = 0; }, 60);
        };
      }
      window.OWHGCart.__bundlePatched = true;
    }
  }

  function init() {
    patch();
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(update).catch(function () {});
    var tries = 0;
    var iv = setInterval(function () {
      patch();
      if (++tries > 20 || (window.OWHGCart && window.OWHGCart.__bundlePatched)) clearInterval(iv);
    }, 100);
  }

  // Optional self-test: append ?OWHG_BUNDLE_TEST=1
  if (/[?&]OWHG_BUNDLE_TEST=1/.test(location.search)) {
    window.OWHG_BUNDLE_TIERS = [{ min: 2, pct: 5 }, { min: 3, pct: 10 }, { min: 5, pct: 15 }];
    var mk = function (n) { return { items: Array.from({ length: n }, function () { return { handle: 'c', quantity: 1 }; }), }; };
    window.OWHG_CLUB_HANDLES = ['c'];
    console.assert(clubCount(mk(3)) === 3, 'count 3');
    console.assert(currentTier(1) === null, 'no tier at 1');
    console.assert(nextTier(1).needed === 1 && nextTier(1).pct === 5, 'next at 1 -> 5% needs 1');
    console.assert(currentTier(3).pct === 10, 'tier at 3 -> 10%');
    console.assert(nextTier(3).needed === 2 && nextTier(3).pct === 15, 'next at 3 -> 15% needs 2');
    console.assert(currentTier(6).pct === 15 && nextTier(6) === null, 'tier at 6 -> 15%, no next');
    console.log('[OWHGBundle] self-test complete');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
